import React, { useCallback, useEffect, useState } from 'react';
import { Text, SearchInput } from '@shakkerai/pro-components';
import { Icon } from '@shakkerai/components';
import styles from './index.modules.scss';
import { translate } from '@shakkerai/util-i18n';
import { useSelectRegulate, useComfirmModalState } from '../../store/base';
import { eventBus } from '@starflow/app/helpers';

import { useBatchImageHooks } from '../../hooks/eventHooks';
import {
  EVENT_LABEL_BATCH_COLLECTED,
  EVENT_LABEL_BATCH_DELETED,
  EVENT_LABEL_BATCH_UNCOLLECTED,
  EVENT_LABEL_INIT_RESORT,
} from '../../utils/eventbus';

const typeConfig = [
  {
    iconClass: 'icon-prolistings',
    text: translate('history_tab1'),
  },
  {
    iconClass: 'icon-prorecord',
    text: translate('common_collect'),
  },
];

export const TopBar = (props) => {
  const { onSearch, onSortChange, selectedTab, setSelectedTab, listData, reloadStoreage, isHome } = props;

  const { selectMode, clearSelect, selectAll, isSelectedAll, isCollectAll, unselectAll } = useSelectRegulate(listData);

  // 收藏、删除等事件发生后广播的名称，
  const eventEmitLabel = (selectedTab === 0 ? 'event_historyList' : 'event_ablumDetail') + 'bat';

  const { deleteAll, downloadAll, collectAll, uncollectALL } = useBatchImageHooks((callbackType, selectedId) => {
    // 接口处理完成后，交给dataHooks处理本地数据部分
    if (callbackType === EVENT_LABEL_BATCH_COLLECTED) {
      eventBus.emit(eventEmitLabel, 'colected', selectedId);
    } else if (callbackType === EVENT_LABEL_BATCH_UNCOLLECTED) {
      eventBus.emit(eventEmitLabel, 'uncolected', selectedId);
    } else if (callbackType === EVENT_LABEL_BATCH_DELETED) {
      // 需要记录页面偏移量，刷新后滚动至偏移量
      eventBus.emit(eventEmitLabel, 'deleted', selectedId);
      unselectAll();
      reloadStoreage();
    }
  });

  const { showComfirmModal } = useComfirmModalState();

  return (
    <div className="relative">
      <div
        className={`flex items-center justify-between gap-2 ${styles.topbar}`}
        style={{
          opacity: selectMode ? 0 : 1,
        }}
      >
        <div className="p-[2px] rounded-[4px] bg-[#F4F6F8]">
          {typeConfig.map((item, index) => (
            <span
              onClick={() => setSelectedTab(index)}
              className={`inline-block align-middle cursor-pointer w-[52px] text-center text-[12px] leading-[17px] py-[4px] ${
                index === selectedTab ? 'rounded-[2px] bg-[#FFF] text-[#2D2D2D]' : 'text-[#ADADAD]'
              }`}
              key={item.iconClass}
            >
              {item.text}
            </span>
          ))}
        </div>
        <SearchSort onSearch={onSearch} isHome={isHome} onSortChange={onSortChange}></SearchSort>
      </div>
      {(!isHome || selectedTab !== 0) && (
        <div
          className={styles.regulateBar}
          style={{
            left: selectMode ? 0 : '102%',
          }}
        >
          <Text
            onClick={() => (isSelectedAll ? unselectAll() : selectAll())}
            iconClass={isSelectedAll ? 'icon-time-1' : 'icon-proyuanquan'}
            className={styles.selectionItem}
            color="var(--color-primary-dark)"
          >
            {isSelectedAll ? translate('history_unselectall') : translate('history_selectall')}
          </Text>
          <Text
            onClick={() => {
              // enableScroll(); // 事件完毕后不再刷新数据，因此不需要开启滚动 2024年01月10日15:42:33
              isCollectAll ? uncollectALL() : collectAll();
            }}
            iconClass="icon-procollect"
            className={styles.selectionItem}
            color="var(--color-primary-dark)"
          >
            {isCollectAll ? translate('common_uncollect') : translate('common_collect')}
          </Text>
          {false && (
            <Text
              onClick={downloadAll}
              iconClass="icon-prodownloa"
              className={styles.selectionItem}
              color="var(--color-primary-dark)"
            >
              {translate('common_download')}
            </Text>
          )}
          <Text
            onClick={() => {
              // enableScroll(); // 事件完毕后不再刷新数据，因此不需要开启滚动
              showComfirmModal({
                content: translate('history_deletesingleimage'),
                subContent: translate('history_deletecheck_sub'),
                onConfirmCallback: () => {
                  deleteAll();
                },
              });
            }}
            iconClass="icon-prodelet"
            className={styles.selectionItem}
            color="var(--color-primary-dark)"
          >
            {translate('common_delete')}
          </Text>
          {/* {isMainland && ( // 2024年02月28日 实现了分享图片到社区的能力，又不需要上线了
          <Text
            onClick={() => {
              if (selectCount <= 8) {
                shareAll();
              } else {
                notifyError(`单次分享图片最多支持8张`);
              }
            }}
            iconClass="icon-prodelet"
            className={styles.selectionItem}
            color="var(--color-primary-dark)"
          >
            分享图片
          </Text>
        )} */}
          <Text
            onClick={clearSelect}
            iconClass="icon-a-proexit"
            className="bg-[var(--color-primary-dark)] pt-1 pb-1 pl-3 pr-3 rounded-[6px]"
            color="white"
          >
            {translate('history_exitselection')}
          </Text>
        </div>
      )}
    </div>
  );
};

export const SearchSort = (props) => {
  const { onSearch, onSortChange, isHome } = props;
  const [isDescendOrder, setIsDescendOrder] = useState(true);

  const innerClick = useCallback(() => {
    setIsDescendOrder(!isDescendOrder);
    onSortChange(isDescendOrder ? 1 : -1);
  }, [onSortChange, isDescendOrder]);

  useEffect(() => {
    const init = () => {
      setIsDescendOrder(true);
    };

    eventBus.on(EVENT_LABEL_INIT_RESORT, init);

    return () => {
      eventBus.off(EVENT_LABEL_INIT_RESORT, init);
    };
  }, []);

  return (
    <div className={`flex items-center ${isHome ? '' : 'grow'}`}>
      {!isHome && (
        <SearchInput
          className="grow"
          radius="4"
          onSearch={onSearch}
          placeholder={translate('history_search_placeholder')}
        />
      )}

      <div className={styles.sort} onClick={() => innerClick()}>
        <Icon
          class={`${isDescendOrder ? 'icon-a-prodescendingorder' : 'icon-a-proascendingorder'} cursor-pointer p-2`}
          fontSize={'16px'}
          color={'#2c2c2c'}
        />
      </div>
    </div>
  );
};
